import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAdminSession } from "utils/adminSession";
import { clearClientSession } from "utils/clientSession";

function decodeOwnerHash(hash) {
  const raw = (hash || "").startsWith("#") ? hash.slice(1) : hash;
  if (!raw) return null;
  const b64 = raw.replace(/-/g, "+").replace(/_/g, "/");
  const padLen = (4 - (b64.length % 4)) % 4;
  const padded = b64 + "=".repeat(padLen);
  try {
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

/**
 * Réception de session après connexion sur /owner-login (fragment #), même origine que le front.
 * Désactivé en production sauf REACT_APP_ALLOW_OWNER_HASH=1 (risque si activé sans réflexion).
 */
export default function OwnerSessionBridge() {
  const navigate = useNavigate();
  const [deny, setDeny] = useState(false);

  useEffect(() => {
    const allow =
      process.env.NODE_ENV !== "production" ||
      process.env.REACT_APP_ALLOW_OWNER_HASH === "1";
    if (!allow) {
      setDeny(true);
      return;
    }

    const data = decodeOwnerHash(window.location.hash);
    const maxAge = 5 * 60 * 1000;
    if (
      !data ||
      data.isAdmin !== true ||
      data.clientId == null ||
      typeof data.at !== "number"
    ) {
      window.location.replace("/owner-login");
      return;
    }
    if (Date.now() - data.at > maxAge) {
      window.location.replace("/owner-login");
      return;
    }

    clearClientSession();
    saveAdminSession({
      clientId: data.clientId,
      isAdmin: true,
      at: data.at,
      source: data.source === "env" ? "env" : "client",
    });
    window.history.replaceState(null, "", window.location.pathname);
    navigate("/admin/default", { replace: true });
  }, [navigate]);

  if (deny) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-900 text-white">
      <p className="text-sm text-gray-300">Ouverture de la session…</p>
    </div>
  );
}
